import React, { useState } from 'react';
import { pollService } from '../api/services';
import './PollWidget.css';

// 投票顯示與互動元件。poll 結構來自後端 getPollForResponse：
// { id, question, poll_type, status, options:[{id,label,vote_count}], total_votes, my_votes:[], has_voted }
// 投票後或投票已結束時顯示各選項百分比；尚未投票則顯示可勾選的選項。
const PollWidget = ({ poll, onUpdate }) => {
  const [selected, setSelected] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!poll) return null;
  const isMultiple = poll.poll_type === 'MULTIPLE';
  const closed = poll.status === 'CLOSED';
  // 已投票、或投票已結束時，呈現結果（百分比）；否則呈現可操作的選項
  const showResults = poll.has_voted || closed;
  const total = poll.total_votes || 0;

  const toggle = (optionId) => {
    if (isMultiple) {
      setSelected((prev) => (prev.includes(optionId) ? prev.filter((x) => x !== optionId) : [...prev, optionId]));
    } else {
      setSelected([optionId]);
    }
  };

  const submit = async () => {
    if (!selected.length) { setError('請至少選擇一個選項'); return; }
    setSubmitting(true);
    setError('');
    try {
      const res = await pollService.vote(poll.id, selected);
      if (onUpdate) onUpdate(res.data); // 以後端回傳的最新票數更新父層
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="poll-widget">
      <div className="poll-widget-head">
        <span className="poll-widget-icon">📊</span>
        <span className="poll-widget-question">{poll.question}</span>
        <span className="poll-widget-type">{isMultiple ? '複選' : '單選'}</span>
      </div>

      {error && <div className="poll-widget-error">{error}</div>}

      <div className="poll-widget-options">
        {poll.options.map((o) => {
          const pct = total > 0 ? Math.round((o.vote_count / total) * 100) : 0;
          const mine = (poll.my_votes || []).includes(o.id);
          if (showResults) {
            return (
              <div key={o.id} className={`poll-result ${mine ? 'mine' : ''}`}>
                <div className="poll-result-bar" style={{ width: `${pct}%` }} />
                <div className="poll-result-text">
                  <span className="poll-result-label">{mine ? '✓ ' : ''}{o.label}</span>
                  <span className="poll-result-pct">{pct}%（{o.vote_count}）</span>
                </div>
              </div>
            );
          }
          return (
            <label key={o.id} className="poll-choice">
              <input
                type={isMultiple ? 'checkbox' : 'radio'}
                name={`poll-${poll.id}`}
                checked={selected.includes(o.id)}
                onChange={() => toggle(o.id)}
                disabled={submitting}
              />
              <span>{o.label}</span>
            </label>
          );
        })}
      </div>

      <div className="poll-widget-foot">
        {!showResults && (
          <button type="button" className="btn btn-sm btn-primary" onClick={submit} disabled={submitting}>
            {submitting ? '送出中...' : '投票'}
          </button>
        )}
        <span className="poll-widget-total">共 {total} 票{closed ? '．已結束' : ''}</span>
      </div>
    </div>
  );
};

export default PollWidget;
